
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseListItemContainer from '@/containers/base/BaseListItemContainer.vue'
import BaseSubNavContainer from '@/containers/base/BaseSubNavContainer.vue'
import {optionsVslim} from '@/config/v-slim-dialog'

const prospectModule = namespace('prospect')
const propositionModule = namespace('proposition')
const documentModule = namespace('document')

@Component({
  components: {
    BaseSubNavContainer,
    BaseListItemContainer
  }
})
export default class ProspectProposition extends Vue {
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @propositionModule.Action('deletePropositionAction') deleteProposition: any
  @propositionModule.Action('generatePDFPropositionAction') generatePDFProposition: any
  @documentModule.Action('downloadDocumentAction') downloadDocument: any

  panel = null

  async onDelete(id: number) {
    const {ok} = await this.$dialogs.confirm('Confirmez vous la suppression de la proposition ?', optionsVslim)
    if (ok) {
      this.deleteProposition(id).then(async () => {
        await this.getProspectById(this.$route.params.id)
      })
    }
  }

  generateHandler(id) {
    this.generatePDFProposition(id).then(async (data) => {
      await this.getProspectById(this.$route.params.id)
      Vue.notify({
        group: 'user',
        type: 'success',
        title: 'Confirmation',
        text: "La proposition a été generée, vous pouvez la télécharger en cliquant sur l'icone, ou la récuperer dans l'espace Documents"
      })
    })
  }

  mailBuilderHandler(data: object) {
    this.panel = this.$showPanel({
      component: 'emailBuilderPanel',
      openOn: 'right',
      width: 700,
      keepAlive: false,
      props: {
        proposition: data,
        prospect: this.prospect
      }
    })
  }

  onDownload(item: any) {
    this.downloadDocument(item)
  }

  hasOffreOptions(item) {
    return (
      item.PROPOSITION_SECRETARIAT === 1 ||
      item.PROPOSITION_EMPLOYES === 1 ||
      item.PROPOSITION_COACHING === 1 ||
      item.PROPOSITION_AUDIT === 1 ||
      item.PROPOSITION_DEMARRAGE === 1 ||
      item.PROPOSITION_ASSISTANCE_INCLUSE === 1
    )
  }

  getOffreOptions(item) {
    const p = []
    if (item.PROPOSITION_SECRETARIAT === 1) p.push(' Secrétariat')
    if (item.PROPOSITION_EMPLOYES === 1) p.push(' Employés')
    if (item.PROPOSITION_COACHING === 1) p.push(' Coaching')
    if (item.PROPOSITION_AUDIT === 1) p.push(' Audit')
    if (item.PROPOSITION_DEMARRAGE === 1) p.push(' Démarrage')
    if (item.PROPOSITION_ASSISTANCE_INCLUSE === 1) p.push(' Assistance incluse')
    return p.toString()
  }
}
